import React from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, DialogProps } from '@producer/ui-kit';

import { VersionManagerItem } from './version-manager-item';
import { Asset } from '../../../app/entities';

import styles from './version-manager.module.scss';
interface VersionManagerProps extends DialogProps {
  asset: Asset;
  selectedVersion: string;
}

export const VersionManager: React.FC<VersionManagerProps> = observer(
  ({ asset, selectedVersion, onClose }) => (
    <Dialog title="Version manager" onClose={onClose}>
      <div className={styles['modal-content']}>
        {asset.sortedChildren.map((version) => (
          <VersionManagerItem
            key={version._id}
            isSelected={selectedVersion === version._id}
            version={version}
            canDelete={asset.children.length > 1}
          />
        ))}
      </div>
    </Dialog>
  ),
);
